import { Fragment } from 'react'

type Props = {
};

const NoItem = ({}: Props) => {
  const openCamera = () => {
    window.nativeOpenCamera()
  }
  return (
    <Fragment>
      <div className="album-empty">
          <div className="image">
            <img src="/images/img_notfound.svg" alt="" />
          </div>
          <div className="content-completed__box">
              <h2 className="text-center">참여가능 사진이 없어요!</h2>
              <div className="note text-center">
                스포키즈캐릭터 카메라로 사진을 찍어보세요!
              </div>
          </div>
          <div className="button">
            <button
              type="button"
              className="btn col-12 btn-block btn-primary"
              onClick={openCamera}
            >
              카메라 바로가기
              {/*{' '}*/}
              {/*<img
                className="mb-1 ml-2"
                src="/images/album/icon_next_btn_w.svg"
                alt=""
              />*/}
            </button>
          </div>
      </div>
      {/*<div className="container mt-5 pt-5">
        <div className="row pt-5">
          <div className="col-12">
            <p className="text-center p-0 m-0">참여 가능한 사진이 없습니다.</p>
            <p className="text-center p-0 m-0">스포키즈 캐릭터 카메라로 사진 촬영 후 랭킹에 참여해보세요!</p>
          </div>
        </div>
        <div className="row mt-5 mr-3 ml-3">
          <div className="col-12 text-center">
            <button
              type="button"
              className="btn col-12 btn-rounded btn-block btn-primary"
              onClick={openCamera}
            >
              카메라 바로가기{' '}
              <img
                className="mb-1 ml-2"
                src="/images/album/icon_next_btn_w.svg"
                alt=""
              />
            </button>
          </div>
        </div>
      </div>*/}
    </Fragment>
  )
}

NoItem.defaultProps = {
};
export default NoItem;
